/**
 * Standardized icon color constants
 * All icons should use these colors for consistency across the application
 * Matches drawer navigation style: light grey when not hovered/selected, black when hovered/selected
 */

// Icon color values - matching drawer navigation style
export const ICON_COLORS = {
  // Default state - light grey (matches drawer inactive icons)
  default: "#71717a",

  // Hover/selected state - black (matches drawer active/hovered icons)
  hover: "#000000",
  selected: "#000000",
  active: "#000000",

  // Primary action color (dark green) - for specific primary actions
  primary: "#1C4321",

  // Secondary/neutral color - lighter grey
  secondary: "#9E9E9E",

  // Text color - follows text color from theme
  text: "rgba(0, 0, 0, 0.87)",

  // Disabled state
  disabled: "rgba(0, 0, 0, 0.26)",

  // Error/warning
  error: "#CD0303",
} as const;

/**
 * Icon color types
 */
export type IconColor =
  | typeof ICON_COLORS[keyof typeof ICON_COLORS]
  | "inherit"
  | "primary"
  | "secondary"
  | "error"
  | "action";

/**
 * Get icon color based on theme color name
 */
export function getIconColor(
  colorName:
    | "primary"
    | "secondary"
    | "text"
    | "disabled"
    | "error"
    | "inherit"
    | "default" = "default"
): string {
  if (colorName === "inherit") {
    return "inherit";
  }
  if (colorName === "default") {
    return ICON_COLORS.default;
  }
  return ICON_COLORS[colorName];
}
